import React from "react";
import { UiButtonIcon } from "../../../../styles/img/UiButtonIcon";

export const PointsCard = (props) => {
    return (
        <>
            <div className="sb-points-card">
                <div className="sb-points-card__yelow-top-right-tr"></div>
                <div className="sb-points-card__gray-bottom-left-tr"></div>
                <div className="sb-points-card__gray-bottom-right-tr"></div>

                <div className="sb-points-card__content">
                    <h2>Top-Up Points!</h2>

                    <p>
                        From its medieval origins to the digital era, learn everything there is to know about the ubiquitous lorem ipsum passage.
                    </p>

                    <p>
                        From its medieval origins to the digital era, learn everything there is to know about the ubiquitous lorem ipsum passage.
                    </p>

                    <div className="sb-points-card__content__link">Top Up Now <UiButtonIcon /></div>

                </div>
            </div>
        </>
    )
}